<template>
    <div>
        <header>
            <div class="grid-content grid-unstackable">
                <div class="grid-item no-flex show-on-tablet">
                    <r-button class="has-icon" @click="showMobileNav">
                        <v-icon :icon="mobileMenuIcon"/>
                    </r-button>
                </div>
                <search/>
                <div class="grid-item no-flex show-on-tablet">
                    <r-button class="has-icon has-tooltip-bottom" data-tooltip="Coming Soon">
                        <r-icon icon="stream"/>
                    </r-button>
                </div>
                <div class="grid-item no-flex hide-on-tablet">
                    <r-button class="has-icon-left has-tooltip-bottom" data-tooltip="Coming Soon">
                        <r-icon icon="stream"/>
                        Recent Activity
                    </r-button>
                </div>
            </div>
        </header>
        <mobile-menu @close="showMobileNav" :show-menu="mobileNav" :menu-items="menuItems"></mobile-menu>
        <nav class="hide-on-tablet">
            <div class="logo stack-l cursor-pointer" v-push="{name: 'dashboard'}" @mouseover="closeAll">
                <div class="mr-re"></div>
                <div class="mr-bil"></div>
                <div class="mr-ly"></div>
            </div>
            <router-link v-for="(item, index) in menuItems"
                         :key="index"
                         :to="item.route"
                         class="btn has-icon has-tooltip-right stack-s"
                         :data-tooltip="item.label"
                         @mouseover="closeAll"
            >
                <v-icon :icon="item.icon"></v-icon>
            </router-link>
            <div class="nav-secondary-actions">
                <div>
                    <a
                        target="_blank"
                        href="https://help.rebilly.com/rebilly-basics/getting-started-guide"
                        class="btn has-icon has-tooltip-right stack-s"
                        data-tooltip="Guides"
                        @mouseover="closeAll"
                    >
                        <v-icon icon="guides"></v-icon>
                    </a>
                </div>
                <div @mouseover="closeAll">
                    <router-link
                        v-if="$auth.$pages['settings'].isAllowed"
                        :to="{name: 'settings'}"
                        class="btn has-icon has-tooltip-right stack-s" data-tooltip="Settings">
                        <v-icon icon="settings"></v-icon>
                    </router-link>
                </div>
                <div @mouseover="closeUserMenu">
                    <alerts-menu ref="alerts"/>
                </div>
                <div @mouseover="closeAlertsMenu">
                    <v-popper2
                        :state="showUserMenu"
                        slide-from="left"
                        direction="vertical"
                        position="bottomEnd"
                        :offset="16">
                        <template #trigger="{popper}">
                            <user-avatar
                                :description="false"
                                @mouseenter.native="popper.open"/>
                        </template>
                        <template #content="{popper}">
                            <user-popover
                                @logout="logout"
                                :popper="popper"/>
                        </template>
                    </v-popper2>
                </div>
            </div>
        </nav>
        <div class="nav-mobile-overlay" v-if="mobileNav" @click="showMobileNav" :class="{'is-active': mobileNav}"></div>
    </div>
</template>

<script>
    import {
        vIcon, vIconSprites, vIconButton,
    } from '@/components/form';
    import vPopper2 from '@/components/popper/v-popper2';
    import UserPopover from '@/modules/layouts/components/user-popover';
    import UserAvatar from '@/modules/layouts/components/user-avatar';
    import MobileMenu from '@/modules/layouts/components/mobile-menu';
    import AlertsMenu from '@/modules/layouts/components/alerts-menu/alerts-menu';
    import Search from '@/components/search/search';
    import topMenuItems from './menu/top-menu';

    export default {
        components: {
            vIconSprites,
            vIconButton,
            vIcon,
            vPopper2,
            MobileMenu,
            AlertsMenu,
            UserAvatar,
            UserPopover,
            Search,
        },
        data() {
            return {
                mobileNav: false,
                showUserMenu: null,
            };
        },
        computed: {
            menuItems() {
                return topMenuItems.nodes
                    .filter(({route}) => route && route.name
                        && this.$auth.$pages[route.name].isAllowed);
            },
            mobileMenuIcon() {
                return !this.mobileNav ? 'burger' : 'close';
            },
        },
        methods: {
            showMobileNav() {
                document.body.classList.toggle('nav-mobile-is-active');
                this.mobileNav = !this.mobileNav;
            },
            closeUserMenu() {
                this.showUserMenu = false;
                this.$nextTick(() => {
                    this.showUserMenu = null;
                });
            },
            closeAlertsMenu() {
                this.$refs.alerts.closeAlertsMenu();
            },
            closeAll() {
                this.closeAlertsMenu();
                this.closeUserMenu();
            },
            logout() {
                // to prevent re-drawing of empty user data we close
                // the menu first and then redirect to logout
                this.closeAll();
                this.$router.push({name: 'logout'});
            },
        },
    };
</script>
